<div [ngStyle]="{ direction: textDir, height: '100%' }" [className]="textDir">
  <router-outlet></router-outlet>
</div>